import React, { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { Link } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import "./SignIn.css";
import { useModal } from "../../context/ModalContext";

const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const ForgottenPass = ({ minHeight }) => {
  console.log({ minHeight })
  const [email, setEmail] = useState("");
  const [mailsent, setMailSent] = useState(false);
  const [error, setError] = useState("");
  const { setCurrentModal } = useModal();

  const handleResetPassword = async (event) => {
    event.preventDefault();
    const auth = getAuth();
    try {
      console.log("Sending password reset email to:", email);

      // This sends an email containing the Firebase-generated oobCode.
      await sendPasswordResetEmail(auth, email);
      setMailSent(true);
      setError("");
    } catch (err) {
      console.error("Failed to send password reset email:", err);
      setError("Please enter a valid email address.");
      setMailSent(false);
    }
  };

  return (
    <div className="signin-container" css={{ minHeight: `${minHeight - 50}px`, [mq[0]]: { minWidth: "405px" } }} >
      <div css={{ height: "50px" }} />
      <Link to="/" css={{ cursor: "pointer" }}>
        <img src="/images/fullproof_logo_black.svg" alt="Fullproof" css={{ height: "40px", marginBottom: 10, [mq[0]]: { height: "50px" } }} />
      </Link>
      <div css={{ flex: 1, display: "flex", flexDirection: "column", width: "100%" }}>
        <div css={{ height: 50 }}>{error && <p className="error">{error}</p>}</div>

        {mailsent ? (
          <div css={{ width: "100%", maxWidth: "440px", margin: "10px auto" }}>
            <div css={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <img src="/images/thumb_up.png" alt="Thumb Up" css={{ width: "40%", maxWidth: 100, marginBottom: 10 }} />
            </div>
            <div css={{ textAlign: "center", padding: "10px 0", fontSize: "1.6rem", fontWeight: 600 }}>Thank you!</div>
            <div css={{ padding: "10px 0" }}>If the information you entered matches our records, we will send you an email with a password reset link.</div>
            <div css={{ height: 10 }} />
            <div css={{ maxWidth: "340px", margin: "10px auto" }}>
              <button type="submit" className="btn btn-primary" css={{ borderRadius: 100 }} onClick={() => setCurrentModal(null)}>
                Close
              </button>
            </div>
          </div>
        ) : (
          <>
            <div css={{ fontSize: "1.2rem", fontWeight: 600, paddingBottom: 0, color: "black", textAlign: "left", [mq[0]]: { fontSize: "1.5rem" } }}>Forgot Password</div>
            <form noValidate className="signin-form" onSubmit={handleResetPassword} css={{ flex: 1, marginTop: 10 }}>
              <label css={{ color: "black" }}>Enter your email address</label>
              <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
              <button type="submit" className="btn btn-primary" css={{ borderRadius: 100 }}>
                Submit
              </button>
              <p
                className="footer-text"
                onClick={() =>
                  setCurrentModal("signIn")
                }
                css={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px", marginTop: "20px" }}
              >
                <ArrowBackIcon /><span>Back to{' '}<u>Sign In</u></span>
              </p>
            </form>
          </>
        )}
      </div>
    </div >
  );
};

export default ForgottenPass;
